/** Тексты пространства «decision». Ключи именуются по смыслу, а не по месту. */
export const decision = {
  filter: {
    target: 'Вид',
    verdict: 'Вердикт',
    allTargets: 'Всё',
    anyVerdict: 'Любое решение',
    approved: 'Принято',
    rejected: 'Отклонено',
  },

  /** Журнал персонала: решения по всем персонажам. */
  log: {
    loading: 'Поднимаем журнал',
    empty: {
      title: 'Записей нет',
      text: 'По выбранным условиям решений не нашлось. Журнал заполняется сам при каждом решении модератора.',
    },
  },

  /** Лента игрока: решения по его собственным заявкам. */
  feed: {
    error: 'Не получилось загрузить решения',
    hint: 'Вердикты по заявкам этого персонажа, свежие сверху. Комментарий обязателен только у отказа.',
    empty: {
      title: 'Решений пока нет',
      text: 'Здесь появится всё, что модераторы ответили по анкете, предметам, питомцам и способностям.',
    },
  },
} as const;
